<template>
  <section>
    <el-row class="header">
      <el-col :span="3">
        <div class="logo-box">
          <img src="../assets/img/logo.png" class="logo">
        </div>
      </el-col>
      <el-col :span="11">
        <div class="systitle">比爱玛智慧工地管理平台</div>
      </el-col>
      <el-col :span="8" class="userinfo">
        <span class="h_space" v-if="GLOBAL.user.comName!=null && GLOBAL.user.comName!=''">{{GLOBAL.user.comName}}</span>

        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
            <i class="el-icon-user-solid" v-if="userPhoto=='' || userPhoto==null"></i>
            <img :src="this.GLOBAL.basePhotoPath+userPhoto" v-if="userPhoto!='' && userPhoto!=null" class="icon-img"/>
            {{sysUserName}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="openPwdView">修改密码</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-col>
      <el-col :span="2" v-if="GLOBAL.user.comPhoto!=null && GLOBAL.user.comPhoto!=''">
        <span class="h_space" ><img :src="GLOBAL.basePhotoPath+GLOBAL.user.comPhoto" class="logo"></span>
      </el-col>
    </el-row>
    <!--主模块-->
    <el-row class="main">
      <!--侧边栏-->
      <el-col :span="3" class="left-menu">
        <el-menu :default-active="$router.path" class="left-menu-box" :collapse="isCollapse" router>
          <el-menu-item index="/overview">
            <i class="left-menu-text">总览</i>
          </el-menu-item>

          <el-submenu index="2">
            <template slot="title">
              <i class="left-menu-text">技术管理</i>
            </template>
            <el-menu-item index="/technology-drawing">图纸管理</el-menu-item>
            <el-menu-item index="/technology-change">变更管理</el-menu-item>
            <el-menu-item index="/model">模型管理</el-menu-item>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title">
              <i class="left-menu-text">安全管理</i>
            </template>
            <el-menu-item index="/safe-disclose">安全交底</el-menu-item>
            <el-menu-item index="/safe-rectify">安全整改</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="left-menu-text">质量管理</i>
            </template>
            <el-menu-item index="quality-disclose">质量交底</el-menu-item>
            <el-menu-item index="quality-rectify">质量整改</el-menu-item>
          </el-submenu>

          <el-menu-item index="/construction">
            <i class="left-menu-text">绿色施工</i>
          </el-menu-item>
          <el-submenu index="6">
            <template slot="title">
              <i class="left-menu-text">设备管理</i>
            </template>
            <el-menu-item index="/device-register">设备注册</el-menu-item>
            <el-menu-item index="/device-material">资料管理</el-menu-item>
<!--            <el-menu-item index="/device-user">人员管理</el-menu-item>-->
            <el-menu-item index="/device-check">设备维保与检查</el-menu-item>
            <el-menu-item index="/device-data">设备数据</el-menu-item>
<!--            <el-menu-item index="/device-machine">地磅系统</el-menu-item>-->
            <el-menu-item index="/device-tower">塔吊布局</el-menu-item>
          </el-submenu>
<!--          <el-menu-item index="/monitor">-->
<!--            <i class="left-menu-text">监控管理</i>-->
<!--          </el-menu-item>-->
          <el-submenu index="8">
            <template slot="title">
              <i class="left-menu-text">实名制管理</i>
            </template>
            <el-menu-item index="/user-register">管理人员注册登记</el-menu-item>
            <el-menu-item index="/user-worker">工人注册登记</el-menu-item>

<!--            <el-menu-item index="/user-attendance">考勤查询</el-menu-item>-->
<!--            <el-menu-item index="/user-salary">工资单查询</el-menu-item>-->
<!--            <el-menu-item index="/user-work">工作查询</el-menu-item>-->
<!--            <el-menu-item index="/user-unattendance">未出勤人员统计</el-menu-item>-->
<!--            <el-menu-item index="/user-unattendancet">近十天未出勤统计</el-menu-item>-->
          </el-submenu>
          <el-menu-item index="/message">
            <i class="left-menu-text">工程动态</i>
          </el-menu-item>
          <el-submenu index="10">
            <template slot="title">
              <i class="left-menu-text">在线考试</i>
            </template>
            <el-menu-item index="/exam">创建考试</el-menu-item>
            <el-menu-item index="/exam_online">在线考试</el-menu-item>
          </el-submenu>
          <el-menu-item index="/progress">
            <i class="left-menu-text">进度管理</i>
          </el-menu-item>
          <el-submenu index="9">
            <template slot="title">
              <i class="left-menu-text">系统管理</i>
            </template>
            <el-menu-item index="/sys-company">公司管理</el-menu-item>
            <el-menu-item index="/sys-project">项目管理</el-menu-item>
            <el-menu-item index="/sys-role">岗位角色</el-menu-item>
          </el-submenu>

        </el-menu>

      </el-col>

      <!--内容区-->
      <el-col :span="21" class="content-box">
        <el-row>
          <el-col :span="24" class="breadcrumb-container">
            <el-breadcrumb separator="" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path" v-if="item.path != '/welcome'">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <transition name="fade" mode="out-in">
              <router-view/>
            </transition>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="footer-box">比爱玛智慧工地管理平台（web端） V1.0 &copy; 苏州比爱玛信息科技有限公司 版权所有</div>
    <!-- 修改密码视图 -->
    <el-dialog title="修改密码" :visible.sync="pwdVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="pwdVisible">
        <el-form :model="formObj"  :rules="formRules" ref="formObj" label-width="100px">
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="formObj.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="formObj.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doSubmit">提交</el-button>
            <el-button @click="doReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {updatePwd} from '../api/api'
  export default {
    name: 'Home',
    data () {
      let validatePass = (rule, value, callback) => {
        console.log(value)
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.formObj.checkPass !== '') {
            this.$refs.formObj.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formObj.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        isCollapse: true,
        sysUserName:'',
        userPhoto:'',
        pwdVisible:false,
        formObj:{ password: '',checkPass: '',},
        formRules: {
          password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      //退出登录
      logout: function () {
        let _this = this;
        this.$confirm('确认退出吗?', '提示', {
        }).then(() => {
          sessionStorage.removeItem('user');
          _this.$router.push('/');
        }).catch(() => {
        });
      },
      //修改密码
      openPwdView:function(){
        this.pwdVisible = true;
      },
      doSubmit:function(){
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              this.formObj.userId = this.GLOBAL.user.id;
              updatePwd(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    sessionStorage.removeItem('user');
                    this.$router.push('/');
                  }
                });
            }).catch(() => {
            });
          }
        });
      },
      doReset() {
        this.$refs.formObj.resetFields();
      }
    },
    mounted() {
      let user = sessionStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        this.sysUserName = user.employeeName || '';
        this.userPhoto = user.employeePhoto || '';
      }else{
        this.$router.push('/');
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/global-vars";
  /*Home页面样式*/
  .header {
    height: 60px;
    line-height: 60px;
    background: $bgcolor;
  }

  .header .logo-box {
    border-color: $m-border-color;
    border-right-width: 1px;
    border-right-style: solid;
    height: 60px;
    width: 200px;
  }

  .header .logo {
    height: 50px;
    padding: 5px 20px 0 0;
    float: right;
  }

  .header .userinfo {
    text-align: right;
    padding-right: 20px;
  }

  .header .userinfo-inner {
    cursor: pointer;
    color:$font-white-color;
  }

  .header .systitle {
    font-size: 18px;
    color: $font-white-color;
    text-indent: 2em;
  }

  .main .left-menu-box {
    position: fixed;
    height: 100%;
    width: 200px;
    text-align: center;
  }
  .main .left-menu-text {
    font-style: normal
  }
  .content-box{position: fixed;right: 0;height: 100%;overflow-y: scroll; padding-bottom: 80px}
  .breadcrumb-inner{height: 60px; line-height: 60px; }
  .h_space{margin-left: 10px; color: #ffffff;}
  .footer-box{position: absolute; left: 0; bottom: 0px; height: 30px; line-height: 30px;background: #3e7d27; width: 100%;
              text-align: center; color: #fff;
             }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue